<template>
    <div class="flex flex-row gap-4 items-center text-5xl">
        <BrainIcon class="size-12 text-gray-700" />
        <span class="font-light text-gray-700">{{ $t('scenario-loading') }}</span>
    </div>
</template>

<script setup lang="ts">
import BrainIcon from '../Icon/BrainIcon.vue';
</script>
